import { Component, Input, OnInit } from '@angular/core';
import { Store } from '../../store/store';
import { StoreService } from '../../store/store.service';

@Component({
  selector: 'app-store-image',
  templateUrl: './store-image.component.html',
  styleUrls: ['./store-image.component.scss'],
})
export class StoreImageComponent implements OnInit {
  @Input() store: Store | undefined;
  @Input() maxWidth = '100px';
  storeImage = 'assets/images/no-store-image.svg';

  constructor(private readonly storeService: StoreService) {}

  ngOnInit(): void {
    this.storeImage = this.storeService.getImageUrlCached(this.store!);
  }
}
